module.exports = __webpack_public_path__ + "static/media/404box-notext.cd4dd8a9.png";